/* eslint-disable */
(function () {
  window._rollbarConfig = {
    accessToken: ENV_CONSTANTS.ROLLBAR_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: ENV_CONSTANTS.ENV,
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: COMMITHASH,
        },
      },
    },
    telemetryScrubber: function (data) {
      var id = data.id;
      var element = document.getElementById(id);

      if (!element) return;

      return element.hasAttribute('data-secret');
    },
    hostWhiteList: ['ebanx.com'],
    checkIgnore: function(isUncaught, args, payload) {
      const [ message ] = args;

      const messageIgnorePatterns = [
        /(SyntaxError|SecurityError|Syntax error|Erro de sintaxe|Script error)/,
        /(Loading chunk (\d+) failed|NetworkError|A ligação à rede foi cortada|Esgotou-se o tempo limite da solicitação)/,
        /(cross-origin|frame with origin)/,
        /3000ms timeout exceeded/,
        /BP-SA-3/, // Merchant account is not active
        /document.getElementsByName\('x-app-title'\)/, // Error from Merchant Habitissimo App
        /Can't find variable: __webpack_require__/,
        /EBANX LibJS was not loaded/,
        /Network request failed/,
        /(A conexão de rede foi perdida|The network connection was lost|La conexión de red se perdió)/,
        /Cannot read property 'setItem' of null/,
        /(O software provocou o cancelamento da conexão|El software causó la anulación de la conexión)/,
        /La conexión a Internet parece estar desactivada/,
        /Se ha agotado el tiempo de espera/,
        /(Falha ao buscar|No se pudo recuperar)/,
        /La conexión a internet parece estar desactivada/,
        /Tectonics - missing action or hash/,
        /(Can't find variable: Tectonics|Tectonics is not defined)/,
        /There is instalment with "Infinity"/,
        /CI-404 Invalid invoice/,
        /CI-405 Expired invoice/,
        /Cannot create payment request/,
        /ChunkLoadError/,
      ];

      return messageIgnorePatterns.some(pattern => pattern.test(message));
    },
  };

  require('rollbar/dist/rollbar.snippet');

})();
